import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppContext} from "../app-context";

@Injectable()
export class AuthenticationTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url === AppContext.getRefreshUrl()) {
      req = req.clone({
        withCredentials: true
      });
    }
    return next.handle(req);
  }
}
